function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "ohub90x87a",
  width: "165.2%",
  height: "200%",
  x: "-32.6%",
  y: "-50%",
  filterUnits: "objectBoundingBox"
}, React.createElement("feMerge", null, React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", null, React.createElement("g", {
  filter: "url(#ohub90x87a)",
  transform: "translate(-1430 -728) translate(1430 726)"
}, React.createElement("path", {
  fill: "#7552F6",
  d: "M110.176 13.292l12.76 25.52c.711 1.423.135 3.153-1.288 3.864-.81.405-1.765.405-2.576 0L107.6 36.94l-11.472 5.736c-1.423.711-3.153.135-3.864-1.288-.405-.81-.405-1.765 0-2.576l12.76-25.52c.711-1.423 2.441-2 3.864-1.288.557.279 1.01.73 1.288 1.288z",
  transform: "scale(-1 1) rotate(-45 0 287.11)"
}), React.createElement("g", {
  fillRule: "nonzero",
  transform: "translate(37 42)"
}, React.createElement("rect", {
  width: 54,
  height: 28,
  x: .76,
  y: .12,
  fill: "#7552F6",
  rx: 4.8
}), React.createElement("path", {
  fill: "#FFF",
  d: "M22.035 20.16v-1.367H16.01v-4.185h5.712v-1.35H16.01V9.352h6.025V7.985H14.49V20.16h7.544zm3.772 0v-5.636c0-1.283 1.004-2.21 2.388-2.21.287 0 .81.05.928.084v-1.452c-.186-.025-.49-.042-.726-.042-1.206 0-2.253.624-2.523 1.51h-.135v-1.35h-1.383v9.096h1.45zm5.645-10.85c.557 0 1.013-.456 1.013-1.013 0-.557-.456-1.013-1.013-1.013-.557 0-1.012.456-1.012 1.013 0 .557.455 1.012 1.012 1.012zm.726 10.85v-9.096h-1.451v9.096h1.45zm6.244.16c2.186 0 3.544-1.232 3.806-2.902H40.76c-.27 1.03-1.123 1.595-2.346 1.595-1.62 0-2.666-1.334-2.666-3.435 0-2.058 1.03-3.366 2.666-3.366 1.308 0 2.11.734 2.346 1.637h1.468c-.253-1.62-1.603-2.945-3.814-2.945-2.548 0-4.168 1.84-4.168 4.674 0 2.895 1.628 4.742 4.176 4.742z"
})))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 141,
    height: 90,
    viewBox: "0 0 141 90"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/eric-cursor.17f354ac.svg";
export { SvgComponent as ReactComponent };